import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import LoadingButton from '@/components/Buttons/LoadingButton';
import { invalidateAfterVerificationChange } from '@/queries/saidv';
import { createCancelIDVerification } from '@/services/TreefortService';
import { errorSnackbar, successSnackbar } from '@/utils/snackbar';

interface Props {
    clientRequestId?: string;
    prospectId?: string;
    onClose: () => void;
}

export default function ConfirmWithdrawDialog({ clientRequestId, prospectId, onClose }: Props) {
    const queryClient = useQueryClient();
    const [isLoading, setIsLoading] = useState(false);

    const handleConfirmWithdraw = async () => {
        if (!clientRequestId) return;

        setIsLoading(true);
        try {
            await createCancelIDVerification(clientRequestId);
            await invalidateAfterVerificationChange(queryClient, prospectId);
            successSnackbar('ID Verification cancelled successfully!');
            onClose();
        } catch (error) {
            console.error('Error cancelling ID Verification:', error);
            errorSnackbar('Failed to cancelling ID Verification');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Dialog open onClose={onClose}>
            <DialogTitle>Confirm Withdrawal</DialogTitle>
            <DialogContent>Are you sure you want to cancel this ID Verification?</DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="outlined" color="primary">
                    Cancel
                </Button>
                <LoadingButton
                    loading={isLoading}
                    onClick={handleConfirmWithdraw}
                    variant="contained"
                >
                    Confirm
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
}
